export default __webpack_public_path__ + "static/customer_sprague_thumb_2-764668999a324e93cc1a38d2b6f29b69.png";